import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@cencosud-cencommerce/paris-uikit';

import { LABEL_SAVE_ADDRESS } from '@/sections/address/components/AddressForm/constants';
import type { AddressFormValues } from '@/sections/address/types/AddressFormValues';

export const SaveAddress = () => {
  const { control } = useFormContext<AddressFormValues>();

  return (
    <div className="co-flex co-gap-6 co-flex-col">
      <Controller
        control={control}
        name="save-address"
        render={({ field: { value, ...nField } }) => (
          <Checkbox label={LABEL_SAVE_ADDRESS} {...nField} checked={value} />
        )}
      />
    </div>
  );
};

SaveAddress.displayName = 'SaveAddress';

export default SaveAddress;
